import { jsx as _jsx } from "react/jsx-runtime";
import { Plus } from '@nike/nike-design-system-icons';
export function IconActionButton({ onClick, ariaLabel = 'Add', showOnHover = true }) {
    const hoverClasses = showOnHover
        ? 'opacity-0 group-hover:opacity-100 transition-opacity'
        : '';
    return (_jsx("button", { type: "button", "aria-label": ariaLabel, onClick: onClick, className: `w-8 h-8 p-0 border-none bg-[#F7F7F7] cursor-pointer rounded flex items-center justify-center hover:bg-[#EEEEEE] ${hoverClasses}`, children: _jsx(Plus, { className: "w-4 h-4 text-[#999999]" }) }));
}
